module.exports = __webpack_public_path__ + "img/coupon.45f81fa0.svg";